import { useResource } from './ResourceProvider';
import { PolicyInput, PolicyInputProps } from '../PolicyInput';

const getTooltipTitle = (
  resource: 'cpu' | 'memory',
  emtyValueOnDisabledResource: boolean
) =>
  emtyValueOnDisabledResource
    ? `${
        resource === 'cpu' ? 'CPU' : 'Memory'
      } optimization is not enabled in this scaling policy.`
    : `${
        resource === 'cpu' ? 'CPU' : 'Memory'
      } optimization is not enabled in this scaling policy. The value is used to generate the suggested request.`;

export type ResourceInputProps = {
  resource: 'cpu' | 'memory';
  name?: string;
  emtyValueOnDisabledResource?: boolean;
} & Omit<PolicyInputProps, 'name' | 'testId'>;

export const ResourceInput = ({
  resource,
  name,
  disabled,
  emtyValueOnDisabledResource = false,
  ...props
}: ResourceInputProps) => {
  const { useDisabledResource } = useResource();

  const isDisabled = useDisabledResource(resource);

  const inputPropsWhenEmptyValue =
    isDisabled && emtyValueOnDisabledResource
      ? {
          type: 'text',
          value: '-',
        }
      : null;

  return (
    <PolicyInput
      {...props}
      name={name ? `${resource}.${name}` : resource}
      disabled={isDisabled || disabled}
      {...inputPropsWhenEmptyValue}
      infoTooltip={
        isDisabled
          ? getTooltipTitle(resource, emtyValueOnDisabledResource)
          : null
      }
      testId={name ? `${resource}-${name}` : resource}
    />
  );
};
